import WithGASetup from '../WithGASetup';
import Confirmation from './Confirmation';

export default WithGASetup(Confirmation);
